module.exports = __webpack_public_path__ + "img/img_winner.c6c5b7e3.png";